<template>
    <div class="filter-period">
        <div class="filter-label" @click="showOptions = !showOptions">
            <span class="far" :class="[options.icon]"></span> {{ valueLabel }}
        </div>
        <div
            class="filter-options"
            v-if="showOptions"
            v-click-outside="clickedOutsideOptions"
        >
            <input
                type="text"
                v-model="searchQuery"
                :placeholder="t('reportFilters-search_placeholder')"
                class="filter-search"
                :name="name"
                :id="`filter-${name}-search`"
            />
            <ul class="filter-list">
                <li
                    v-for="(option, index) in filteredOptions"
                    :key="index"
                    @click="toggleOption(option.value)"
                >
                    <input
                        type="checkbox"
                        :checked="isChecked(option.value)"
                        @click.stop
                        @change="toggleOption(option.value)"
                        :id="`filter-${name}-${index}`"
                        :name="name"
                    />
                    <label>{{ option.label }}</label>
                </li>
            </ul>
            <div class="filter-actions">
                <button
                    type="button"
                    class="cancelBtn btn btn-sm btn-default"
                    @click="cancel"
                >
                    {{ t('reportFilters-cancel') }}
                </button>
                <button
                    type="button"
                    class="applyBtn btn btn-sm btn-success"
                    @click="apply"
                >
                    {{ t('reportFilters-apply') }}
                </button>
            </div>
        </div>
    </div>
</template>

<style lang="less" scoped>
.filter-list {
    max-height: 204px;
    overflow-y: auto;
    li {
        input {
          cursor: pointer;
        }
    }
}

.filter-search {
    width: 100%;
    padding: 5px;
    margin-bottom: 10px;
    box-sizing: border-box;
}
</style>

<script>
export default {
    name: "filter-checkbox",
    props: {
        options: {
            type: [Object, Array],
            default: () => ({}),
        },
        name: {
            type: String,
            default: "filter-checkbox",
        },
        currentValue: {
            type: [Array, String, Number],
            default: null,
        },
    },
    data() {
        return {
            showOptions: false,
            clickedOutsideOptions: () => {},
            value: [],
            newValue: [],
            changedValue: false,
            searchQuery: "",
        };
    },
    mounted() {
        if (this.currentValue) {
            this.value = this.currentValue;
            this.newValue = [...this.value];
        }
        if (this.value.length > 0) {
            this.changed();
        }
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        toggleOption(value) {
            let idx = this.newValue.indexOf(String(value));
            if (idx === -1) {
                this.newValue.push(String(value));
            } else {
                this.newValue.splice(idx, 1);
            }
        },
        isChecked(value) {
            return this.newValue.indexOf(String(value)) !== -1;
        },
        apply() {
            this.value = [...this.newValue];
            this.showOptions = false;
        },
        cancel() {
            this.newValue = [...this.value];
            this.showOptions = false;
        },
        changed() {
            this.$emit("changed", this.value.length > 0 ? this.value : null);
        },
    },
    computed: {
        valueLabel() {
            if (this.value.length === 0) {
                return this.t('reportFilters-select');
            }
            let label = this.value
                .map((value) => this.optionsMap[value])
                .join(", ");
            if (label.length > 30) {
                label = label.substr(0, 27) + "...";
            }
            return label;
        },
        optionsMap() {
            let optionsMap = {};
            for (let o in this.options.options) {
                let option = this.options.options[o];
                optionsMap[option.value] = option.label;
            }
            return optionsMap;
        },
        filteredOptions() {
            if (!this.searchQuery) {
                return this.options.options;
            }
            return this.options.options.filter((option) =>
                option.label.toLowerCase().includes(this.searchQuery.toLowerCase())
            );
        },
    },
    watch: {
        showOptions() {
            if (this.showOptions) {
                window.setTimeout(() => {
                    this.clickedOutsideOptions = () => {
                        if (this.showOptions) {
                            this.cancel();
                        }
                    };
                }, 100);
            } else {
                this.clickedOutsideOptions = () => {};
            }
        },
        value() {
            this.changed();
        },
    },
};
</script>
